import { render, staticRenderFns } from "./OpdView.vue?vue&type=template&id=c4868322"
import script from "./OpdView.vue?vue&type=script&lang=js"
export * from "./OpdView.vue?vue&type=script&lang=js"
import style0 from "./OpdView.vue?vue&type=style&index=0&id=c4868322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports